"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DeleteObjectsInput_1 = require("./DeleteObjectsInput");
var DeleteObjectsOutput_1 = require("./DeleteObjectsOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.DeleteObjects = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "DeleteObjects",
    http: {
        method: "POST",
        requestUri: "/{Bucket}?delete"
    },
    input: {
        shape: DeleteObjectsInput_1.DeleteObjectsInput
    },
    output: {
        shape: DeleteObjectsOutput_1.DeleteObjectsOutput
    },
    errors: []
};
//# sourceMappingURL=DeleteObjects.js.map